import {ButtonRect, CloseButton} from "../../../../components/UxCommon";
import React from "react";

export default function ({title, wrapperClass, question, inviteQuestion, options, inviteOptionValue, inviteOption, btnMsg, onSubmitClick, onCancelClick}) {
  return (
    <div className={`ConfirmDialogWrapper ${wrapperClass ? wrapperClass : ''}`}>
      <div className="ConfirmDialog">
        <CloseButton size={10} onClick={onCancelClick}/>
        <div className="AlbumDialod_ConfirmOptionDialog_Title">
          {title}
        </div>
        <div className="AlbumDialod_ConfirmOptionDialog_Question">
          {question}
        </div>
        <div className="AlbumDialod_ConfirmOptionDialog_wrapper">
          <div className="AlbumDialod_ConfirmOptionDialog_Options_Question">
            <strong>{inviteQuestion}</strong>
          </div>
          <div className="AlbumDialod_ConfirmOptionDialog_options">
            <ul>
              {Object.entries(options).map(([item, title]) =>
                <li key={title}>
                  <input type="radio" id={item} checked={item === inviteOptionValue} name='invite-option'
                         onClick={() => inviteOption(item)} value={item}/>
                  <label htmlFor={item}>{title}</label>
                </li>
              )}
            </ul>
          </div>
        </div>
        <ButtonRect
          className="AlbumDialod_ConfirmOptionDialog_Btn primary"
          onClick={onSubmitClick}
        >
          {btnMsg || 'Delete'}
        </ButtonRect>
        <ButtonRect
          className="AlbumDialod_ConfirmOptionDialog_Btn"
          onClick={onCancelClick}
        >
          Cancel
        </ButtonRect>
      </div>
    </div>
  );
}
